import { isDefined } from './objectUtils';

export const booleanFeatureFlag = (raw: string | undefined): boolean =>
  isDefined(raw) && raw.trim().toLowerCase() === 'true';
